document.addEventListener('on:variant:change', (event) => {
  let variantOptions = event.detail.variant.options;
  let descriptionSection = document.querySelector('.color-description-section');
  let matchedDescription = ''; // Fixed: was missing variable declaration
  
  // Get the product title for conditional checks
  let productTitle = event.detail.product?.title || document.querySelector('.product-title')?.textContent || '';

  // Object to hold all color descriptions
  let colorDescriptions = {
    "Birch": "Natural, organic, relaxed. A speckled satin white glaze, like birch bark.",
    "Matte Black": "Sophisticated, luxe, warm. A satin matte finish like polished charred wood.",
    "Burl": "Earthy, inviting, unique, like petrified wood with charcoal and golden flecks.",
    "Buttermilk Pink": "Subtle, creamy, pastel. A warm, satin floral pink.",
    "Vivian Howard's Buttermilk Pink": "Subtle, creamy, pastel. A warm, satin floral pink.",
    "Celadon": "Cool, fresh, mineral light green, with a satin finish.",
    "Concrete": "Variegated, industrial, mineral. A speckled, varied texture surface.",
    "Coquina": "Warm, neutral, coastal. A warm satin tan with sandy speckles.",
    "Fern": "Lush, botanical, sumptuous, a deep green mottled with lighter greens.",
    "Matte Grey": "Modern, minimal, elegant. A neutral, contemporary, cool matte grey.",
    "Mariana": "Oceanic, rich, satiny, and slightly mottled, like water.",
    "Pompeii": "Volcanic, saucy, earthy. A fiery red-orange reminiscent of terracotta.",
    "Robins' Egg": "Jewelled, friendly, bright. A satiny true Carolina blue.",
    "Robin's Egg": "Jewelled, friendly, bright. A satiny true Carolina blue.",
    "Terra": "Earthen, natural, clean. Unglazed brown porcelain outer, satin white interior.",
    "Turmeric": "Warm, citrus, spiced. A vibrant rich yellow with pepper-like speckles.",
    "Vespertine": "Marine, starry, deep. A glossy night-sky navy with emerald green edges.",
    "Matte White": "Clean, crisp, classic. A satiny matte white with warm undertones.",
    "Moonstone": "Mineral, speckled white, with depth and detail that reveals itself on close inspection.",
    "Serpentine": "Deep, variegated green with darker veins. Somewhere between a reptile and jewel, 100% unique.",
    "Cloudware": "Marbleized sky blue and white unglazed, colored porcelain outer, glazed blue interior.",
    "Stormware": "Marbleized stormy gray and white unglazed porcelain outer, glazed gray interior. (Discontinued)",
    "Berlin": "Pompeii, Turmeric, Mariana, Black and Grey.  Bold, Bauhaus inspired primary colors.",
    "Mendoza": "Fern, Birch, Vespertine, Coquina, Concrete. A mountain inspired color palette from the heart of Argentina's wine country.",
    "Sedona": "Pompeii, Coquina, Mariana, Matte Black. Far out, southwestern vibes."
  };

  // Check for variants with conditional logic based on product title
  variantOptions.forEach(option => {
    // Oslo variants
    if (option.includes('Oslo')) {
      if (productTitle.includes('3 Piece Ripple')) {
        matchedDescription = "Matte White, Matte Grey, Celadon. Scandi, refined vibes at home anywhere.";
      } else if (productTitle.includes('4 Piece Ripple')) {
        matchedDescription = "Matte White, Matte Grey, Celadon. Scandi, refined vibes at home anywhere.";
      } else if (productTitle.includes('3 Piece Serving')) {
        matchedDescription = "Matte White, Concrete, Celadon. Scandi, refined vibes at home anywhere.";
      } else {
        matchedDescription = "Matte White, Matte Grey, Celadon, Matte Black, Birch. Scandi, refined vibes at home anywhere.";
      }
    }
// Piedmont variants
else if (option.includes('Piedmont')) {
  if (productTitle.includes('3 Piece Hestia')) {
    matchedDescription = "Birch, Fern, Burl. Feels like an ancient, earthy forest.";
   } else if (productTitle.includes('5 Piece Hestia')) {
    matchedDescription = "Birch, Fern, Burl, Matte Black, Matte White. Feels like an ancient, earthy forest.";
  } else if (productTitle.includes('3 Piece Ripple')) {
    matchedDescription = "Birch, Matte Black, Burl. Feels like an ancient, earthy forest.";
      } else if (productTitle.includes('3 Piece Skali')) {
    matchedDescription = "Birch, Matte Black, Burl. Feels like an ancient, earthy forest.";
          } else if (productTitle.includes('4 Piece Ripple')) {
    matchedDescription = "Birch, Matte Black, Burl. Feels like an ancient, earthy forest.";
  } else {
    matchedDescription = "Birch, Matte Black, Burl, Fern. Feels like an ancient, earthy forest.";
  }
}
    // San Tropez variants
    else if (option.includes('San Tropez')) {
      if (productTitle.includes('3') || productTitle.includes('Hestia') || productTitle.includes('4')) {
        matchedDescription = "Pink, Celadon, Matte White. Beachy, laid back vibes with a Mediterranean flair.";
      } else {
        matchedDescription = "Pink, Celadon, Matte White. Beachy, laid back vibes with a Mediterranean flair.";
      }
    }
    // Moraine variants
    else if (option.includes('Moraine')) {
      if (productTitle.includes('3')) {
        matchedDescription = "Moonstone, Concrete, Burl. A glacial inspired palette of variegated finishes.";
      } else {
        matchedDescription = "Moonstone, Birch, Concrete, Burl. A glacial inspired palette of variegated finishes.";
      }
    }
    // Standard color descriptions
    else if (colorDescriptions[option]) {
      matchedDescription = colorDescriptions[option];
    }
  });
  
  // If a match is found, update the description, otherwise clear it
  if (matchedDescription) {
    descriptionSection.textContent = matchedDescription;
  } else {
    descriptionSection.textContent = ''; // Clear the description if no match is found
  }
});

function onSwymLoadCallback(swat) {
  // Define eventname
  let event = 'sw:addedtocart';
  
  // Define the event listener function
  let listener = function(e) { 
    var data = e.detail.d.productData;	
    console.log("YAY! Added the product to cart", data);
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
    // update button state here...
  };

// Add listener for the 'addedtocart' event to the Swym Event Layer
swat.evtLayer.addEventListener(event, listener);

}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);


/** CUSTOM TRIGGER CART AFTER WISHLIST ITEM ADDED TO CART */

// Add listener for 'addedtocart' event to Rebuy bundle builder

document.addEventListener('rebuy:cart.add', function () {
  // When Rebuy adds something to the cart...
  document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
    bubbles: true
  }));
});



/**
 * JAVASCRIPT DEVELOPER DOCUMENTATION
 *
 * Symmetry is a powerful and customizable theme designed for large-scale e-commerce stores. Built
 * using Web Components, it offers a highly modular architecture that makes customization and
 * maintenance easier than ever. In addition, Symmetry is optimized for speed, ensuring that your
 * store runs as fast as possible to provide your customers with a seamless shopping experience.
 *
 * If you would like to add your own JS to Symmetry, we recommend using this file and referencing
 * it using Theme Settings > Advanced > Custom HTML.
 *
 * As a brief overview, Symmetry:
 *  - Broadcasts many JS events.
 *  - Is built using Web Components.
 *  - Leverages 'code splitting' for some features.
 *  - Is completely custom built (no JS libraries)
 *  - Has a number of JS utilities.
 *
 *
 *
 * =================================================================================================
 * Custom JavaScript Events
 * =================================================================================================
 *
 * Symmetry broadcasts many custom events for ease of extensibility, detailed in this section.
 *
 * When in the Theme Editor, the details of each custom event will be logged out in the Dev Tools
 * console everytime it is triggered.
 *
 * Events are named in the following convention: ["on/dispatch"]:[subject]:[action] (where
 * 'dispatch' will trigger an event to occur, and 'on' indicates an event has occurred).
 *
 * All 'Return data' detailed in this section is returned within the 'event.detail' object.
 *
 * The available events are:
 *  1.  on:variant:change
 *  2.  on:cart:add
 *  3.  on:cart:error
*   4.  on:cart:after-merge
 *  5.  on:cart-drawer:before-open
 *  6.  on:cart-drawer:after-open
 *  7.  on:cart-drawer:after-close
 *  8.  on:quickbuy:before-open
 *  9.  on:quickbuy:after-open
 *  10. on:quickbuy:after-close
 *  11. dispatch:cart-drawer:open
 *  12. dispatch:cart-drawer:refresh
 *  13. dispatch:cart-drawer:close
 *  14. on:debounced-resize
 *  15. on:breakpoint-change
 *
 * -------------------------------------------------------------------------------------------------
 * 1) on:variant:change
 * -------------------------------------------------------------------------------------------------
 * Fires whenever a variant is selected (e.g. Product page, Quickbuy, Featured Product etc).
 *
 * How to listen:
 * document.addEventListener('on:variant:change', (event) => {
 *  // your code here
 * });
 *
 * Returned data:
 *  - form: the product form content
 *  - variant: the selected variant object
 *  - allVariants: an array of all variants
 *  - selectedOptions: an array of currently selected options (e.g. ['Blue', 'Large'])
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 2) on:cart:add
 * -------------------------------------------------------------------------------------------------
 * Fires when a variant has been added to the cart, where it didn't exist in the cart before. This
 * event does not fire when the added variant was already in the cart.
 *
 * How to listen:
 * document.addEventListener('on:cart:add', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - variantId: id of the variant that was just added to the cart
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 3) on:cart:error
 * -------------------------------------------------------------------------------------------------
 * Fires when an action related to the cart has failed, for example adding too much quantity of an
 * item to the cart.
 *
 * How to listen:
 * document.addEventListener('on:cart:error', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - error: the error message
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 4) on:cart:after-merge
 * -------------------------------------------------------------------------------------------------
 * Fires after a list of cart items has finished being dynamically updated after a cart change.
 *
 * How to listen:
 * document.addEventListener('on:cart:after-merge', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 5) on:cart-drawer:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the cart drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 6) on:cart-drawer:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 7) on:cart-drawer:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 8) on:quickbuy:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the quick buy drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 9) on:quickbuy:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 10) on:quickbuy:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 11) dispatch:cart-drawer:open
 * -------------------------------------------------------------------------------------------------
 * Opens the cart drawer (if enabled in the Theme Settings).
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
 *
 * You can optionally pass in a 'detail' object with a property of 'opener', which specifies the DOM
 * element that should be focussed on when the drawer is closed.
 *
 * Example:
 * document.getElementById('header-search').addEventListener('keydown', (evt) => {
 *   if (evt.keyCode === 67) {
 *     evt.preventDefault();
 *     document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
 *       detail: {
 *         opener: evt.target
 *       }
 *     }));
 *   }
 * });
 *
 * In this example, we attach a keydown listener to the search input in the header. If the user
 * presses the 'c' key, it prevents the default behavior (which would be to type the letter 'c' in
 * the input) and dispatches the 'dispatch:cart-drawer:open' event with a 'detail' object that
 * specifies the search input as the opener. When the cart drawer is closed, focus is returned to
 * the search input.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 12) dispatch:cart-drawer:refresh
 * -------------------------------------------------------------------------------------------------
 * Refreshes the contents of the cart drawer.
 *
 * This event is useful when you are adding variants to the cart and would like to instruct the
 * theme to re-render the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
 *   bubbles: true
 * }));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 13) dispatch:cart-drawer:close
 * -------------------------------------------------------------------------------------------------
 * Closes the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 14) on:debounced-resize
 * -------------------------------------------------------------------------------------------------
 * Fires when the viewport finishes resizing (debounced to 300ms by default).
 *
 * How to listen:
 * window.addEventListener('on:debounced-resize', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 15) on:breakpoint-change
 * -------------------------------------------------------------------------------------------------
 * Fires when the breakpoint of the viewport changes.
 *
 * Example:
 * window.addEventListener('on:breakpoint-change', (event) => {
 *  if (theme.mediaMatches.md) {
 *   console.log('we are not on mobile');
 *  }
 * });
 *
 *
 *
 * =================================================================================================
 * Web Components
 * =================================================================================================
 *
 * Symmetry utilizes Web Components to the fullest.
 *
 * Web Components are a set of standardized APIs that allow developers to create custom, reusable
 * HTML elements that can be used across different web pages and applications.
 * Web Components consist of three main technologies: Custom Elements, Shadow DOM and HTML
 * Templates.
 *
 * See Mozilla for more: https://developer.mozilla.org/en-US/docs/Web/Web_Components
 *
 *
 *
 =================================================================================================
 * Third-Party JavaScript Dependencies
 * =================================================================================================
 *
 * Symmetry has no third-party JavaScript dependencies.
 *
 *
 * =================================================================================================
 *
 * Have fun! - The Clean Canvas Development Team.
 */
